// Lightweight Google Analytics 4 helpers.
// gtag is loaded by /public/index.html with config { send_page_view: false }
// so we can fire page_view manually on every React Router navigation.

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-0E7LPMR8JL";

const gtag = (...args) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
};

export const trackEvent = (name, params = {}) => {
  gtag("event", name, params);
};

export const trackPageView = (path, title) => {
  gtag("event", "page_view", {
    page_path: path,
    page_location: typeof window !== "undefined" ? window.location.href : path,
    page_title: title || (typeof document !== "undefined" ? document.title : ""),
    send_to: GA_ID,
  });
};

// Mounts inside <BrowserRouter>; fires page_view on every route change.
export const usePageViews = () => {
  const location = useLocation();
  useEffect(() => {
    // tiny delay so the new page's <title> has been applied
    const t = setTimeout(() => {
      trackPageView(location.pathname + location.search, document.title);
    }, 50);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);
};

// Convenience event helpers
export const trackAffiliateClick = ({ label, category = "affiliate", destination, location: where }) => {
  trackEvent("affiliate_click", {
    event_category: category,
    event_label: label,
    cta_label: label,
    destination,
    location: where,
  });
};

export const trackCTAClick = ({ label, location: where, destination }) => {
  trackEvent("cta_click", {
    event_category: "cta",
    event_label: label,
    cta_label: label,
    location: where,
    destination,
  });
};

export const trackNavClick = (label) => {
  trackEvent("nav_click", { event_category: "nav", event_label: label });
};

export const trackNewsletterSignup = (source) => {
  trackEvent("newsletter_signup", {
    event_category: "engagement",
    event_label: source || "homepage",
    method: "email",
  });
};
